import {
  AbstractDefaultPropsModel,
  MetaImageSizeOptionsType,
  TranslationColumnValueModel,
  UploadModel,
} from '@ckmk/angular';
import { SolutionCategoryModel } from '@app/src/app/modules/solution/classes/category/model/solution.category.model';

export class SolutionModel extends AbstractDefaultPropsModel {
  /**
   * The solution id
   * @protected
   */
  public get id(): string | undefined {
    return this.get('id');
  }
  public set id(id: string | undefined) {
    this.set('id', id);
  }

  /**
   * The solution category
   * @protected
   */
  public get category(): SolutionCategoryModel | undefined {
    return this.get('category');
  }
  public set category(category: any) {
    this.setInstance('category', SolutionCategoryModel, category);
  }

  /**
   * The solution cover
   * @protected
   */
  public get cover(): UploadModel | undefined {
    return this.get('cover');
  }
  public set cover(cover: any) {
    this.setInstance('cover', UploadModel, cover);
  }

  /**
   * The solution picture
   * @protected
   */
  public get picture(): UploadModel | undefined {
    return this.get('picture');
  }
  public set picture(picture: any) {
    this.setInstance('picture', UploadModel, picture);
  }

  /**
   * The solution slug
   * @protected
   */
  public get slug(): string | undefined {
    return this.get('slug');
  }
  public set slug(slug: string | undefined) {
    this.set('slug', slug);
  }

  /**
   * The category title
   * @protected
   */
  public get title(): TranslationColumnValueModel | undefined {
    return this.get('title');
  }
  public set title(title: any | undefined) {
    this.setInstance('title', TranslationColumnValueModel, title);
  }

  /**
   * The category description
   * @protected
   */
  public get description(): TranslationColumnValueModel | undefined {
    return this.get('description');
  }
  public set description(description: any | undefined) {
    this.setInstance('description', TranslationColumnValueModel, description);
  }

  /**
   * The solution short description
   * @protected
   */
  public get shortDescription(): TranslationColumnValueModel | undefined {
    return this.get('shortDescription');
  }
  public set shortDescription(shortDescription: any | undefined) {
    this.setInstance('shortDescription', TranslationColumnValueModel, shortDescription);
  }

  public constructor(data?: any) {
    super(data);
  }

  public override fullName(): TranslationColumnValueModel | string {
    return this.title || '';
  }

  public override metaDescription(): TranslationColumnValueModel | string {
    return this.shortDescription || '';
  }

  public override metaImage(): string {
    return this.picture?.defaultUrl || '';
  }

  public override metaImageSize(): MetaImageSizeOptionsType {
    return this.picture?.dimension() || {};
  }

  protected override onClone(): this {
    return new SolutionModel({
      category: this.category,
      description: this.description?.clone(),
      shortDescription: this.shortDescription?.clone(),
    }) as this;
  }
}
